/** One endpoint (origin or dest) populated by exactly one of the three modes. */
export type Endpoint =
  | { kind: 'stop'; stopId: number }
  | { kind: 'address'; address: string }
  | { kind: 'position'; latitude: number; longitude: number };

/** Coord bundled with an endpoint pick so parents can render a pin at the picked point. */
export interface EndpointPickSource {
  latitude: number;
  longitude: number;
}

/** Fixed-decimal `"lat, lon"` string used for coord-picked labels and hash-query values. */
export function formatLatLon(latitude: number, longitude: number, digits = 5): string {
  return `${latitude.toFixed(digits)}, ${longitude.toFixed(digits)}`;
}
